// extracted by mini-css-extract-plugin
module.exports = {"efcollapse":"EFCollapse_efcollapse__Y0tLV"};